import { inject, Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { environment } from '@/environments/environment.development';
import { Observable } from 'rxjs';
import { ApiResponse } from '@core/domains/interfaces/ApiResponse';

@Injectable({
  providedIn: 'root'
})
export class SuggestionService {
  private baseService = inject(BaseService);

  getSuggestions(): Observable<ApiResponse<any>> {
    return this.baseService.getAll(environment.endPoint.getSuggestions);
  }

  createSuggestion(suggestion: string): Observable<ApiResponse<any>> {
    return this.baseService.create(environment.endPoint.createSuggestion, { suggestion });
  }
}
